import apollo from '@/scripts/apollo';
import { isEdge } from '@/scripts/utils';

// eslint-disable-next-line camelcase
function is_touch_device() {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = query => window.matchMedia(query).matches;

  // eslint-disable-next-line no-mixed-operators,no-undef
  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

export default {
  // When the bound element is inserted into the DOM...
  inserted() {
    // eslint-disable-next-line camelcase
    if (!is_touch_device() && !isEdge()) {
      apollo.ref.addTarget({
        id: 'scale',
        elements: document.querySelectorAll('[data-apollo-hover]'),
        offset: { x: 10, y: 10 },
        callback(target, eventType) {
          if (eventType === 'apollo-mouse-enter') {
            apollo.ref.getProperty('r').value = 20;
          } else if (eventType === 'apollo-mouse-leave') {
            apollo.ref.getProperty('r').value = 60;
          }
        },
      });
    }
  },
};
